<router-outlet></router-outlet>

<app-loader></app-loader>

<app-toaster-container></app-toaster-container>